import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-wrap justify-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 animate-spin text-nominee-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      _ctx.color ? _ctx.color : 'bg-gray-800',
      'inline-block text-xs font-semibold tracking-wider text-center text-white border-white border-opacity-50 rounded-sm shadow-md cursor-pointer select-none hover:bg-opacity-90 border-1 disabled:opacity-70 focus:outline-none hover:border-gray-900 lg:text-sm text-opacity-90 hover:text-opacity-100',
    ]),
    type: _ctx.type
  }, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}